module.exports = __webpack_public_path__ + "img/ergonomic-image2.71a13cd3.png";